/* global axios */
import ApiClient from '../ApiClient';

// SLA composto de uma conversa (Bloco 2 / T-04): decomposição IA/humano/pendência + onde estourou.
class SlaAPI extends ApiClient {
  constructor() {
    super('fandata/conversations', { accountScoped: true });
  }

  composto(conversationDisplayId) {
    return axios.get(`${this.url}/${conversationDisplayId}/sla`);
  }
}

export default new SlaAPI();
